import React from 'react';
import { useNavigate } from 'react-router-dom';
import PauseScreenSlideShow from './PauseScreenSlideShow';
import './PauseScreen.css'

const PauseScreen = () => {
    const navigate = useNavigate();
    
    return (
        <div className='pause-screen-wrapper pause-screen-slide-show' onClick={() => navigate('/')}>
            <div className="pause-text-box">
                Tryk på skærmen for at vende <br/> tilbage til check in skærmen
            </div>
            <PauseScreenSlideShow slideShowId={10035} />
        </div>
    );
};

export default PauseScreen;